import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class InterceptorInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    request = request.clone({
      setHeaders: {
        "Content-Type": "Application/json",
        "Referrer-Policy": "no-referrer"
      }
    });
    return next.handle(request).pipe(
      tap((event: HttpResponse<any>) => {
        if (event.body?.numError === 2400) {
          localStorage.clear()
          this.router.navigate(['/'])
        }
      })
    );
  }
}
